import React, { useCallback, useContext, useState } from "react";
import * as css from "./MetaControl.module.scss";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../../../context/GlobalContextProvider";

import IconHtml from "../../../images/icons/btnicon-html-text.svg";
import IconHideComments from "../../../images/icons/btnicon-hide-comments.svg";
import IconNormal from "../../../images/icons/btnicon-normal.svg";
type MetaControlProps = {
  lang: "ja" | "en";
};
const MetaControl: React.FC<MetaControlProps> = (props) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [selectIsOpen, setSelectIsOpen] = useState(false);

  // 表示設定が変更された場合のハンドラ
  const handleChange = useCallback(
    (e) => {
      dispatch({
        type: "CHANGE_VIEW_MODE",
        viewMode: e.target.value,
      });
    },
    [dispatch]
  );

  const doToggleSelect = useCallback(() => {
    setSelectIsOpen(!selectIsOpen);
  }, [setSelectIsOpen, selectIsOpen]);

  const langs = {
    ja: {
      normal: "手書き表示",
      hidecomments: "手書き表示(コメントオフ)",
      htmltext: "標準表示",
    },
    en: {
      normal: "Handwriting",
      hidecomments: "Handwriting (Hide Comments)",
      htmltext: "Normal Text",
    },
  };

  const labels = props.lang === "ja" ? langs.ja : langs.en;

  return (
    <div>
      {selectIsOpen && (
        <ul className={css.selectRadio}>
          <li>
            <input
                type={`radio`}
                name={`view-mode`}
                id={`view-mode-normal`}
                value={`NORMAL`}
                checked={state.viewMode === "NORMAL"}
                onChange={handleChange}
            />
            <label htmlFor={`view-mode-normal`}>
              {/*<img src={IconNormal} alt="" />*/}
              {labels.normal}
            </label>
          </li>

          <li>
            <input
              type={`radio`}
              name={`view-mode`}
              id={`view-mode-hide-comment`}
              value={`HIDE-COMMENT`}
              checked={state.viewMode === "HIDE-COMMENT"}
              onChange={handleChange}
            />
            <label htmlFor={`view-mode-hide-comment`}>
              {/*<img src={IconHideComments} alt="" />*/}
              {labels.hidecomments}
            </label>
          </li>

          <li>
            <input
                type={`radio`}
                name={`view-mode`}
                id={`view-mode-html`}
                onChange={handleChange}
                value={`HTML`}
                checked={state.viewMode === "HTML"}
            />
            <label htmlFor={`view-mode-html`}>
              {/*<img src={IconHtml} alt="" />*/}
              {labels.htmltext}
            </label>
          </li>
        </ul>
      )}
      <button
        className={
          css.selectRadioTrigger + " " + (!selectIsOpen && css.disabled)
        }
        onClick={doToggleSelect}
      >
        {state.viewMode === "NORMAL" && (
          <span className={css.btnText}>
            {/*<img src={IconHideComments} alt="" />*/}
            <span> {labels.normal}</span>
          </span>
        )}
        {state.viewMode === "HIDE-COMMENT" && (
          <span className={css.btnText}>
            {/*<img src={IconHideComments} alt="" />*/}
            <span> {labels.hidecomments}</span>
          </span>
        )}
        {state.viewMode === "HTML" && (
          <span className={css.btnText}>
            {/*<img src={IconHideComments} alt="" />*/}
            <span> {labels.htmltext}</span>
          </span>
        )}
      </button>
      <div
        className={css.closeBackground + " " + (!selectIsOpen && css.disabled)}
        role={"button"}
        onClick={doToggleSelect}
      />
    </div>
  );
};

export default MetaControl;
